export default [
  { title: 'Create account', to: '/register' },
  { title: 'Sign in', to: '/login' },
];
